import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  contentContainer: {
    '@media (max-width: 768px)': {
      paddingTop: '85px',
    },
  },
  gridContainer: {
    marginTop: '24px!important',
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '52px',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
      marginTop: '24px',
    },
  },
  button: {
    minWidth: '182px !important',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  passwordMatchContainer: {
    marginTop: 24,
  },
  expiredContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  expiredIcon: {
    width: '80px',
    height: '80px',
    marginBottom: '16px',
  },
  expiredTitle: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '40px',
    maxWidth: '400px',
  },
  expiredButton: {
    minWidth: '200px !important',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
  },
}));
